import { useState } from 'react';
import { appData } from '@/mocks/homeData';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full max-w-sm lg:max-w-xs">
              {!imgError ? (
                <img
                  src={appData.image}
                  alt="草民影院移动端观影体验"
                  className="w-full h-auto rounded-2xl"
                  onError={() => setImgError(true)}
                />
              ) : (
                <div className="w-full aspect-[4/3] bg-background-200 rounded-2xl flex items-center justify-center">
                  <i className="ri-smartphone-line text-6xl text-foreground-300"></i>
                </div>
              )}
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg lg:max-w-none">
                {appData.description}
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-8">
                {appData.features.map((feat, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium"
                  >
                    <i className="ri-check-line text-sm"></i>
                    {feat}
                  </span>
                ))}
              </div>

              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-smartphone-line text-lg"></i>
                立即体验移动版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}